export default __webpack_public_path__ + "static/Whitepaper-092a1c63fc91f35b5599b693491a1f77.pdf";